import { render, staticRenderFns } from "./Strategies.vue?vue&type=template&id=041fbd39&scoped=true&"
import script from "./Strategies.vue?vue&type=script&lang=js&"
export * from "./Strategies.vue?vue&type=script&lang=js&"
import style0 from "./Strategies.vue?vue&type=style&index=0&id=041fbd39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041fbd39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/ctorres/Documents/Dev/MCD/lsm-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VContainer,VSelect,VTextarea})
